import React from "react";

function HomeBanner() {
    return (
        <section className="home-promo home-promo--reverse">
            <div className="home-promo-card">
                <div className="home-promo-image home-banner-image">
                    <img src="/img/home_2.jpg" alt="GO Auto"/>
                </div>
                <div className="home-promo-text">
                    <div className="home-promo-content">
                        <h2 className="home-promo-heading">Samochód, finansowanie i formalności — w jednym miejscu</h2>
                        <p className="home-promo-body">
                            W GO-auto wybierasz auto z dużej bazy sprawdzonych dostawców, a dalej korzystasz z zaplecza GO-Leasing: ponad 100 oddziałów doradców w całej Polsce i współpracy z ponad 40 bankami oraz firmami finansującymi.
                        </p>
                        <p className="home-promo-body">
                            Możesz porównać leasing, wynajem, kredyt lub pożyczkę, dobrać ubezpieczenie i GAP, a przy wybranych rozwiązaniach skorzystać także z leasingu z gwarancją zwrotu auta. Wniosek składasz online — wygodnie, bez wychodzenia z domu.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HomeBanner;
